'use strict';exports.__esModule = true;var _constants = require('../constants');
var _modifyImageLink = require('./modifyImageLink');var _modifyImageLink2 = _interopRequireDefault(_modifyImageLink);
var _companyPlaceholder = require('../../static/images/company-placeholder.svg');var _companyPlaceholder2 = _interopRequireDefault(_companyPlaceholder);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var getCompanyLogoUrl = function getCompanyLogoUrl(imageUrl) {return imageUrl ?
  (0, _modifyImageLink2.default)(imageUrl, _constants.imageModifierTypes.LOGO) : _companyPlaceholder2.default;};exports.default =


getCompanyLogoUrl;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/getCompanyLogoUrl.js
// module id = 1294
// module chunks = 0